import React from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";

function HotelRegistration_step_2({ register, errors, setValue }) {
  return (
    <>
      <h5 className="step-heading">
        B. Company Identification (SIRENE / SIRET)
      </h5>
      <div className="form_holder">
        <div className="row">
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>SIRET (Mandatory)</Form.Label>
              <Form.Control
                placeholder="Enter SIRET"
                {...register("siret", {
                  required: "SIRET is required",
                  maxLength: {
                    value: 100,
                    message: "SIRET cannot exceed 100 characters",
                  },
                })}
              />
              {errors?.siret && (
                <Form.Text className="text-danger">
                  {errors?.siret?.message}
                </Form.Text>
              )}{" "}
              <small className="form-hint">
                Company data retrieved via API SIRENE
              </small>
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Legal / Trade Name</Form.Label>
              <Form.Control
                placeholder="Legal / Trade Name"
                {...register("trade_name", {
                  required: "Legal / Trade Name is required",
                  maxLength: {
                    value: 100,
                    message: "Legal / Trade Name cannot exceed 100 characters",
                  },
                })}
              />
              {errors?.trade_name && (
                <Form.Text className="text-danger">
                  {errors?.trade_name?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>SIREN</Form.Label>
              <Form.Control
                placeholder="SIREN"
                {...register("siren", {
                  required: "SIREN is required",
                  maxLength: {
                    value: 100,
                    message: "SIREN cannot exceed 100 characters",
                  },
                })}
              />
              {errors?.siren && (
                <Form.Text className="text-danger">
                  {errors?.siren?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Activity Code (APE / NAF)</Form.Label>
              <Form.Control
                placeholder="Activity Code (APE / NAF)"
                {...register("activity_code", {
                  required: "Activity Code (APE / NAF) is required",
                  maxLength: {
                    value: 100,
                    message:
                      "Activity Code (APE / NAF) cannot exceed 100 characters",
                  },
                })}
              />
              {errors?.activity_code && (
                <Form.Text className="text-danger">
                  {errors?.activity_code?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Legal Form</Form.Label>
              <Form.Control
                placeholder="Legal Form"
                {...register("legal_form", {
                  required: "Legal Form is required",
                  maxLength: {
                    value: 100,
                    message: "Legal Form cannot exceed 100 characters",
                  },
                })}
              />
              {errors?.legal_form && (
                <Form.Text className="text-danger">
                  {errors?.legal_form?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Number of Employees</Form.Label>
              <Form.Control
                placeholder="Number of Employees"
                {...register("number_of_employee", {
                  required: "Number of Employees is required",
                  maxLength: {
                    value: 100,
                    message: "Number of Employees cannot exceed 100 characters",
                  },
                })}
              />
              {errors?.number_of_employee && (
                <Form.Text className="text-danger">
                  {errors?.number_of_employee?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Internship Capacity / Year</Form.Label>
              <Form.Control
                placeholder="Internship Capacity / Year"
                {...register("internship_capacity", {
                  required: "Internship Capacity / Year is required",
                  maxLength: {
                    value: 100,
                    message:
                      "Internship Capacity / Year cannot exceed 100 characters",
                  },
                })}
              />
              {errors?.internship_capacity && (
                <Form.Text className="text-danger">
                  {errors?.internship_capacity?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-12">
            <Form.Group className="mb-3">
              <Form.Label>Registered Address</Form.Label>
              <Form.Control
                as="textarea"
                role="2"
                placeholder="Registered Address"
                {...register("registered_address", {
                  required: "Registered Address is required",
                  maxLength: {
                    value: 100,
                    message: "Registered Address cannot exceed 100 characters",
                  },
                })}
              />
              {errors?.registered_address && (
                <Form.Text className="text-danger">
                  {errors?.registered_address?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-12">
            <Form.Check
              className="mb-3"
              label="I confirm compliance with local labor and internship laws"
              {...register("compliance_confirm", {
                required: "You must confirm compliance to continue",
              })}
              isInvalid={!!errors?.compliance_confirm}
            />

            {errors?.compliance_confirm && (
              <Form.Text className="text-danger">
                {errors.compliance_confirm.message}
              </Form.Text>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default HotelRegistration_step_2;
